/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled from 'styled-components';
import { Media } from "../../../styles/utilities";


/*********************************************************************************
 2. Component
 *********************************************************************************/

// Flex properties commented out until support for IE11 is dropped
export const StyledMain = styled.main`
  // flex: 1;
  min-height: calc(100vh - 80px);
  ${Media.Tablet`
    min-height: calc(100vh - 150px);
    display: block;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledMain/index.js